module.exports = __webpack_public_path__ + "img/Desktop-1.a6ec42bc.jpg";